import AUCollateralPresets from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/CollateralPresets/AUCollateralPresets';
import NZCollateralPresets from 'modules/addons/components/digital-onboarding/PPSRRegistration/forms/CollateralPresets/NZCollateralPresets';

export { AUCollateralPresets };
export { NZCollateralPresets };
